import { render, staticRenderFns } from "./ToDoCounter.vue?vue&type=template&id=1a54ae4b&scoped=true&"
import script from "./ToDoCounter.vue?vue&type=script&lang=js&"
export * from "./ToDoCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54ae4b",
  null
  
)

export default component.exports